import "./Herosection.css";
const Herosection = (props) => {
  return (
    <div>
      <div className="container-fluid" id="heroback">
        <div className="container-fluid">
          <h1 className="text-white">
            The Greatest Movies <br></br> All In One Place
          </h1>
          <a href="https://www.youtube.com/watch?v=Cg8sbRFS3zU"><i class="far fa-play-circle text-white" id="icon"><span className="ms-2"> 2h 30 min</span></i></a>
          <h4 className="text-white mt-3">Indian army special forces execute a covert operation, avenging the killing of fellow army men at their base by a terrorist group.</h4>
          {/* <button className="mt-4 bg-danger text-white"><i class="fas fa-play"></i><span className="ms-2">WATCH NOW</span></button>
           */}
           {/* <button type="button" className="btn btn-danger mt-3">WATCH NOW</button> */}
        </div>
      </div>
    </div>
  );
};
export default Herosection;
